import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export const formatTimestamp = (date: string) => dayjs(date).format('HH:mm')

export const formatRelativeTime = (date: string) => dayjs(date).fromNow()

export const formatFileSize = (bytes: number) => {
  if (!bytes) return '0 B'
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const size = bytes / Math.pow(1024, i)
  return `${size.toFixed(1)} ${sizes[i]}`
}

const DAYS_OF_WEEK = ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy']
const MONTHS = ['tháng 1', 'tháng 2', 'tháng 3', 'tháng 4', 'tháng 5', 'tháng 6', 'tháng 7', 'tháng 8', 'tháng 9', 'tháng 10', 'tháng 11', 'tháng 12']

export const formatDateSeparator = (date: string): string => {
  const messageDate = dayjs(date)
  const today = dayjs().startOf('day')
  const yesterday = today.subtract(1, 'day')
  const messageDateStart = messageDate.startOf('day')

  if (messageDateStart.isSame(today)) {
    return 'Hôm nay'
  }
  
  if (messageDateStart.isSame(yesterday)) {
    return 'Hôm qua'
  }

  const weekStart = today.startOf('week')
  if (messageDateStart.isAfter(weekStart) || messageDateStart.isSame(weekStart)) {
    const dayOfWeek = messageDate.day()
    return DAYS_OF_WEEK[dayOfWeek]
  }

  if (messageDate.year() === today.year()) {
    return `${messageDate.date()} ${MONTHS[messageDate.month()]}`
  }

  return `${messageDate.date()} ${MONTHS[messageDate.month()]} ${messageDate.year()}`
}

export const isSameDay = (date1: string, date2: string): boolean => {
  return dayjs(date1).startOf('day').isSame(dayjs(date2).startOf('day'))
}



